<script lang="ts">
	import tippy from "svelte-tippy";

	interface Props {
		icon: string;
		type?: string;
		size?: string;
		customClass?: string;
		customSize?: string;
		isClickable?: boolean;
		isLeft?: boolean;
		isRight?: boolean;
		tooltip?: string | null;
		badgeValue?: string | number | null;
		badgePosition?: string;
	}

	let {
		icon,
		type = "",
		size = "",
		customClass = "",
		customSize = "",
		isClickable = false,
		isLeft = false,
		isRight = false,
		tooltip = null,
		badgeValue = null,
		badgePosition = "is-top-right",
	}: Props = $props();

	let svgHref = $derived(`#icon:${icon}`);
	let newCustomSize = $derived(customSize || "");
	let newType = $derived.by(() => {
		if (!type) {
			return "";
		}
		let splitType = type.split("-");
		if (splitType.length <= 1) {
			return "";
		}
		return `has-text-${splitType[1]}`;
	});
</script>

{#if tooltip}
	<span class="icon is-relative {size} {newType} {customClass} {newCustomSize} {(isLeft && 'is-left') || ''} {(isRight && 'is-right') || ''}" class:is-clickable={isClickable} use:tippy={{content: tooltip}}>
		{#if badgeValue != null}
			<span class="badge {badgePosition}">{badgeValue}</span>
		{/if}
		<svg>
			<use xlink:href={svgHref} />
		</svg>
	</span>
{:else}
	<span class="icon is-relative {size} {newType} {customClass} {newCustomSize} {(isLeft && 'is-left') || ''} {(isRight && 'is-right') || ''}" class:is-clickable={isClickable}>
		{#if badgeValue != null}
			<span class="badge {badgePosition}">{badgeValue}</span>
		{/if}
		<svg>
			<use xlink:href={svgHref} />
		</svg>
	</span>
{/if}
